import { emptyPrompt } from './Prompt';
import { promptVars } from './variables';
export const namePrompt = emptyPrompt
    .model('eu.anthropic.claude-3-5-sonnet-20240620-v1:0')
    .temp(0.5)
    .system(`
You are AI for naming applications. You are creating cool names. Format for the name should be with spaces between words. Use application name from user, If user specifies name of application inside Application intent.
Most importantly, output NOTHING but the name. Do not include anything else in your message.
`)
    .human(`
	Application intent:
${promptVars.intent}
Return application name.
`);
//# sourceMappingURL=namePrompt.js.map